module.exports = __webpack_public_path__ + "static/media/title.6614c159.png";